import { useStaticQuery, graphql } from 'gatsby'

export const useSubPages = id => {
  const { allWordpressPage } = useStaticQuery(
    graphql`
      query {
        allWordpressPage(sort: { fields: [menu_order] }) {
          nodes {
            type
            title
            slug
            path
            featured_media {
              id
              source_url
            }
            content
            wordpress_id
            wordpress_parent
            menu_order
            acf {
              audit {
                title
                url {
                  source_url
                }
              }
              graphes {
                title
                subtitle
                picture {
                  source_url
                  title
                }
                content
              }
              subtitle
              headlines
              blocks_page {
                __typename
                ... on WordPressAcf_paragraph {
                  paragraph
                }
                ... on WordPressAcf_video {
                  video
                }
                ... on WordPressAcf_gallery {
                  gallery {
                    source_url
                    title
                  }
                }
                ... on WordPressAcf_image {
                  image {
                    source_url
                    title
                  }
                }
              }
            }
          }
        }
      }
    `
  )
  return allWordpressPage.nodes.filter(node => node.wordpress_parent == id)
}
